import image from "fragments/image"
import mas from "fragments/mas/mas"
import screenshot from "fragments/screenshot"
import techSpec from "fragments/techSpec"
import label from "fragments/vendors/label"
import storeLink from "fragments/vendors/storeLink"
import gql from "graphql-tag"

const homeVideo = gql`
  ${image}
  ${screenshot}
  ${label}
  ${mas}
  ${storeLink}
  ${techSpec}

  fragment HomeVideo on HomeVideo {
    createdAt
    editions
    id
    images {
      ...Image
    }
    screenshots {
      ...Screenshot
    }
    isBluRay
    isPublished
    isUHD
    label {
      ...Label
    }
    mas {
      ...MAS
    }
    name
    newsCount
    publishedAt
    releaseDate
    storeLinks {
      ...StoreLink
    }
    techSpecs {
      ...TechSpec
    }
    updatedAt
  }
`

export default homeVideo
